<script setup lang="ts">
import type {ContentFAQ} from '@/ts/types/dto/home-dto';
import type {Content} from '@/ts/types/dto/interventions-dto';
import type {UuidDTO} from '@/ts/types/dto/sign-in-dto';
import {computed} from 'vue';
import {useI18n} from 'vue-i18n';
import type {SideBarGroupedSection} from '@/ts/types/component/balm-sidebar';
import SidebarName from '@/vue/molecules/sidebar/sidebar-name.vue';
import {buildFaqSections} from '@/ts/composables/pure/use-faq-sidebar';
import SidebarSection from '@/vue/molecules/sidebar/sidebar-section.vue';

const props = withDefaults(defineProps<{
  faq: ContentFAQ[];
  /** The intro video, once it has moved here from the Today page */
  introVideo?: Content | null;
}>(), {
  introVideo: null,
});

const emit = defineEmits<{
  /** An entry's video was watched. Carries the content id, which is the entry's id. */
  videoWatched: [UuidDTO];
}>();

const {t: $t} = useI18n();

const grouped = computed<SideBarGroupedSection[]>(
  () => buildFaqSections(props.faq, props.introVideo, $t('faq_intro_video_title')),
);

</script>
<template>
  <sidebar-name :name="$t('faq')"/>
  <sidebar-section
    v-for="group in grouped"
    :key="group.id"
    :name="group.name"
    :items="group.items"
    @video-watched="emit('videoWatched', $event)"
  />
</template>
